import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface IDriverData {
  cpf: string;
  username: string;
  phoneNumber: string;
}

export default function useBulkCreatePrivateDrivers() {
  const [loading, setLoading] = useState(false);

  async function execute(driversData: IDriverData[], callback?: () => void) {
    try {
      setLoading(true);
      const response = await api.post(`v1/backoffice/private-drivers/bulk`, {
        drivers: driversData,
      });

      if (response.status === 201) {
        if (callback) {
          callback();
        }

        toast.success(ToastMessages.driver.success.createMany);
      }

      if (response.status === 400) {
        toast.error(ToastMessages.driver.error.createMany);
      }
    } catch (error: any) {
      const errorData = error.response.data;
      if (errorData.message)
        toast.error(`Erro de validação: ${errorData.message}`);
      else toast.error(ToastMessages.driver.error.createMany);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
